const projects = [
 
  {
    id: "alpha12",
    slug: "alpha12",
    title: "Alpha12",
    description: [
    "This project was developed as a task, where a Figma design file was provided to be converted into a fully functional, responsive web dashboard using HTML, CSS, and JavaScript.",
     "The implementation uses dummy data to demonstrate dynamic UI components, interactive behavior, and clean modular structure suitable for real-world applications.",
    `
    <ul>
      <li><b>Dynamic Stat Cards:</b> Metric cards and trend indicators generated from dummy data.</li>
      <li><b>Interactive Carousel:</b> Smooth transitions with titles, images, and descriptions.</li>
      <li><b>Custom Bar Chart:</b> Chart.js bar chart with a custom dashed-grid plugin.</li>
      <li><b>Light/Dark Theme Toggle:</b> Persistent theme selection saved via localStorage.</li>
      <li><b>Event Management System:</b> Search, filter, sort, pagination, CSV export, and modal details.</li>
    </ul>
    `
  ],
    imageUrl: "/assets/alpha12bannerimage.png",
    displayImageUrl:  "/assets/alpha12banner.png",
    visitLink: "https://alpha12.vercel.app/",
    figmaLink: "https://www.figma.com/proto/jIDR8wFhfryST7Fn8VthFS/Alpha12?page-id=0%3A1&node-id=2-7589&viewport=411%2C579%2C0.29&t=ggCNi9p33JJArTGl-1&scaling=scale-down-width&content-scaling=fixed&starting-point-node-id=2%3A7589",
    languages: [
      { name: "JavaScript (ES6+)", icon: "react" },
      { name: "HTML5", icon: "chartdotjs" },
      { name: "CSS3", icon: "material-ui" },
      { name: "Chart.js", icon: "material-ui" }
    ]
  },
  {
    id: "threadgpt",
    slug: "threadgpt",
    title: "ThreadGPT",
    description: [
      "An AI-powered conversation platform that enables seamless thread-based discussions.",
      "Integrates advanced language models for intelligent responses and content generation.",
      "Features a clean, minimalist design focused on readability and user engagement."
    ],
    imageUrl: "/assets/threadgptbannerimage.png",
    displayImageUrl:  "/assets/threadgptbanner.png",
    visitLink: "https://threadgpt-blush.vercel.app/",
    figmaLink: "https://www.figma.com/proto/8MzrHEGbV75NsuSXKwYGOy/Threadgpt?page-id=0%3A1&node-id=42-236&p=f&viewport=230%2C305%2C0.07&t=gzSoQWfVwat31ePK-1&scaling=scale-down-width&content-scaling=fixed&starting-point-node-id=42%3A236",
    languages: [
      { name: "Next.js", icon: "nextjs" },
      { name: "OpenAI", icon: "openai" },
      { name: "Prisma", icon: "prisma" }
    ]
  },
  {
    id: "grow",
    slug: "grow",
    title: "Grow",
    description: [
      "An environmental sustainability dashboard to gain insights about your environment.",
      "This project focuses on visualizing sensor data, trends and actionable insights to help users make informed decisions.",
      "Built with a user-first approach, it balances data density with clarity and simplicity."
    ],
    imageUrl: "/assets/growbannerimage.png",
    displayImageUrl:  "/assets/growbanner.png",
    visitLink: "https://example.com/grow",
    figmaLink: "https://www.figma.com/",
    languages: [
      { name: "React", icon: "R" },
      { name: "JavaScript", icon: "JS" },
      { name: "Sass", icon: "S" }
    ],
    isExternal: false
  },
  {
    id: "theloda",
    slug: "theloda",
    title: "TheLoda Website",
    description: [
      "An intuitive music-focused platform designed for enthusiasts, offering streamlined discovery and playlists.",
      "TheLoda emphasizes accessibility and responsiveness across devices with a clean visual language.",
      "Interactions are designed to be delightful while keeping performance and accessibility in mind."
    ],
    imageUrl: "/assets/lodapointbannerimage.png",
    displayImageUrl:  "/assets/lodapointbanner.png",
    visitLink: "https://lodapoint.com/",
    figmaLink: "https://www.figma.com/",
    languages: [
      { name: "React", icon: "R" },
      { name: "Style Component", icon: "TS" }
    ],
    isExternal: false
  },
  
  {
    id: "battregen",
    slug: "battregen",
    title: "Battregen",
    description: [
      "A design & product iteration for Battregen: a project focused on energy storage workflows and dashboards.",
      "The page demonstrates wireframes, flows and a responsive UI for monitoring and managing battery regeneration systems.",
      "I contributed to the interaction design and frontend implementation for prototyping and testing." 
    ],
    imageUrl: "/assets/battregenbannerimage.png",
    displayImageUrl:  "/assets/battregenbanner.png",
    visitLink: "https://battregen.com/",
    figmaLink: "https://www.figma.com/",
    languages: [
      { name: "React", icon: "R" },
      { name: "Node.js", icon: "N" }
    ],
    isExternal: true
  },
  {
    id: "visora-ai",
    slug: "visora-ai",
    title: "Visora AI",
    description: [
      "An AI product showcase for Visora: focusing on automated analytics and insights.",
      "The prototype highlights key flows for onboarding, model configuration and visual reports.",
      "The design balances complex functionality with a streamlined user experience for non-technical users." 
    ],
    imageUrl: "/assets/visorabannerimage.png",
    displayImageUrl:  "/assets/visorabanner.png",
    visitLink: "https://www.visora-ai.com/",
    figmaLink: "https://www.figma.com/",
    languages: [
      { name: "React", icon: "R" },
      { name: "Python", icon: "Py" }
    ],
    isExternal: true
  },
  {
    id: "spacer",
    slug: "spacer",
    title: "Spacer",
    description: [
      "A clean, minimal landing/product page for Spacer, focused on collaborative tools and micro-interactions.",
      "The prototype explores layout systems and motion to make collaboration feel lightweight and fun.",
      "This showcases component systems and responsive breakpoints for consistent experiences." 
    ],
    imageUrl: "/assets/spacerbannerimage.png",
    displayImageUrl:  "/assets/spacerbanner.png",
    visitLink: "https://www.spacer.so/",
    figmaLink: "https://www.figma.com/",
    languages: [
      { name: "React", icon: "R" },
      { name: "Next.js", icon: "N" }
    ],
    isExternal: true
  }
];

export default projects;
